import { AppMain } from '@/locales/samples/AppMain/ja-JP';
import { HelloWorld } from '@/locales/samples/HelloWorld/ja-JP';

import {
  Menue,
  UserInfo,
  FormParts,
  ApiErrorMessage,
  InputErrorMessage,
  Button,
} from '@/locales/common/ja-JP';
import { Dialog } from '@/locales/common/ja-JP';
import { Dispensing } from '@/locales/Dispensing/ja-JP';
import { DispensingReadyCalling } from '@/locales/DispensingReadyCalling/ja-JP';
import { ExplainMedicine } from '@/locales/ExplainMedicine/ja-JP';
import { Delivery } from '@/locales/Delivery/ja-JP';
import { Home } from '@/locales/Home/ja-JP';
import { InfoNotice } from '@/locales/InfoNotice/ja-JP';
import { MedicalInterview } from '@/locales/MedicalInterview/ja-JP';
import { Pharmacy } from '@/locales/Pharmacy/ja-JP';
import { HomeModifyResend } from '@/locales/HomeModifyResend/ja-JP';
import { TakingMedicineSchedule } from '@/locales/TakingMedicineSchedule/ja-JP';
import { Reservation } from '@/locales/Reservation/ja-JP';
import { HomeService } from '@/locales/HomeService/ja-JP';
import { MedicationAlarm } from '@/locales/MedicationAlarm/ja-JP';
import { MedicineList } from '@/locales/MedicineList/ja-JP';
import {
  MyPage,
  EditUser,
  EditEmailAddress,
  UpdatedDialog,
  LicencePage,
} from '@/locales/MyPage/ja-JP';
import { FamilyList } from './FamilyList/ja-JP';
import { ServiceList } from '@/locales/ServiceList/ja-JP';
import { ServiceListEdit } from '@/locales/ServiceListEdit/ja-JP';
import { FirstAccess } from '@/locales/FirstAccess/ja-JP';
import { StringMark } from '@/locales/common/ja-JP';
import { SpecialString } from '@/locales/common/ja-JP';
import { CallSettings } from '@/locales/CallSettings/ja-JP';
import { TermsOfUse } from '@/locales/TermsOfUse/ja-JP';
import { VitalData } from '@/locales/VitalData/ja-JP';
import { CreditCard } from '@/locales/CreditCard/ja-JP';
import { PersonalInformationDisclosure } from '@/locales/PersonalInformationDisclosure/ja-JP';
import { DeliveryAddress } from '@/locales/DeliveryAddress/ja-JP';
import { ReservationHistory } from '@/locales/ReservationHistory/ja-JP';
import { DataShare } from '@/locales/DataShare/ja-JP';
import { FollowUpMessage } from '@/locales/FollowUp/ja-JP';
import { AppLinkageSettings } from './AppLinkageSettings/ja-jp';
import { UploadImages } from './UploadImages/ja-JP';
import { TakingMedicineRecord } from '@/locales/TakingMedicineRecord/ja-JP';
import { TakingMedicineCheck } from '@/locales/TakingMedicineCheck/ja-JP';
import { ErrorHandle } from '@/locales/ErrorHandle/ja-JP';
import { PrivacyPolicy } from '@/locales/PrivacyPolicy/ja-JP';
import { FuncIntro } from '@/locales/FuncIntro/ja-JP';
import { EcShop } from '@/locales/EcShop/ja-JP';
import { PrescriptionQR } from '@/locales/PrescriptionQR/ja-JP';
import { DataLink } from '@/locales/DataLink/ja-JP';
import { Ubie } from '@/locales/Ubie/ja-JP';
import { HealthCheck } from '@/locales/HealthCheck/en-US';
import { Corporation } from '@/locales/Corporation/ja-JP';
import { YJMedicine } from '@/locales/YJMedicine/ja-JP';
import { CameraAccess } from '@/locales/CameraAccess/ja-JP';
import { SettlementConfirmation } from '@/locales/SettlementConfirmation/ja-JP';
import { MynaPortal } from '@/locales/MynaPortal/ja-JP';
import {
  CardRegisterErrorMessage,
  CardRegisterSettlementErrorMessage,
} from '@/locales/DgftDisplayErrorMessage/ja-JP';
import { QRCodeSetting } from '@/locales/QRCodeSetting/ja-JP';

export const localeJaJP = {
  AppMain,
  HelloWorld,
  Menue,
  Dialog,
  Dispensing,
  DispensingReadyCalling,
  ExplainMedicine,
  Delivery,
  Home,
  InfoNotice,
  MedicalInterview,
  Pharmacy,
  HomeModifyResend,
  TakingMedicineSchedule,
  Reservation,
  HomeService,
  MedicationAlarm,
  MedicineList,
  MyPage,
  EditUser,
  EditEmailAddress,
  UpdatedDialog,
  LicencePage,
  UserInfo,
  FamilyList,
  FormParts,
  ServiceList,
  ServiceListEdit,
  FirstAccess,
  StringMark,
  SpecialString,
  ApiErrorMessage,
  InputErrorMessage,
  CallSettings,
  TermsOfUse,
  VitalData,
  CreditCard,
  PersonalInformationDisclosure,
  DeliveryAddress,
  ReservationHistory,
  DataShare,
  FollowUpMessage,
  AppLinkageSettings,
  UploadImages,
  TakingMedicineRecord,
  TakingMedicineCheck,
  ErrorHandle,
  PrivacyPolicy,
  FuncIntro,
  EcShop,
  PrescriptionQR,
  Button,
  DataLink,
  Ubie,
  HealthCheck,
  Corporation,
  YJMedicine,
  CameraAccess,
  SettlementConfirmation,
  MynaPortal,
  CardRegisterErrorMessage,
  CardRegisterSettlementErrorMessage,
  QRCodeSetting,
};
